<template>
  <div class="pro-content">
    <div class="mine-header">
      <div class="mine-header-user">
        <div class="mine-header-left">
          <div class="mine-use-img">
            <van-image round width="100%" height="100%" :src="headerimg" />
            <img class="real-img" :src="realImg" alt />
          </div>
          <div class="mine-user">
            <div class="check-log" v-if="showLogin" @click="login">点击登录</div>
            <div class="check-log" v-if="showName">{{userName}}</div>
            <div class="log-text">
              <van-image
                width="71px"
                height="18.5px"
                :src="require('../../assets/img/member.png')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 客户服务 -->
    <div class="customer-service">
      <div class="list-nav">常用工具</div>
      <div class="service-icon">
        <div class="promote-right-img" v-for="(item, index) in moduleList" :key="index">
          <div class="home-line" @click="checkUp(item)">
            <div>
              <svg-icon :icon-class="item.img"></svg-icon>
              <p class="promote-right-span">{{item.name}}</p>
            </div>
            <p class="line-icon"></p>
          </div>
        </div>
      </div>
    </div>
    <!-- 其他服务 -->
    <div class="customer-service other-service">
      <div class="list-nav">系统设置</div>
      <div class="other-list">
        <van-cell
          :title="item.title"
          is-link
          v-for="(item, index) in orderData"
          :key="index"
          @click="check(item)"
        >
          <template #icon>
            <svg-icon :icon-class="item.icon"></svg-icon>
          </template>
        </van-cell>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { Dialog, Toast } from 'vant';
 import { jspay, setSession, setLocal } from '@/utils/utils';
import URL from "@/api/api";
export default {
  data() {
    return {
      headerimg: require(`../../assets/img/user.png`),
      realImg: require(`../../assets/publicImg/real-name.png`),
      userName: "",
      isLogin: '',
      showName: false,
      showLogin: true,
      baseUrl: "https://dtfcloud.com/",
      moduleList: [
        {
          name: "我的订单",
          img: "mine_icon1",
          path: "/order",
        },
        {
          name: "我的经纪人",
          img: "mine_icon3",
          path: "/myBroker",
        },
        // {
        //   name: "浏览记录",
        //   img: "mine_icon5",
        //   path: "/history",
        // },
        {
          name: "产品筛选",
          img: "mine_icon5",
          path: "/activity",
        },
        {
          name: "信贷方案",
          img: "mine_icon5",
          path: "/activity",
        },
        {
          name: "计算器",
          img: "mine_icon5",
          path: "/activity",
        },
        {
          name: "活动记录",
          img: "mine_icon5",
          path: "/activity",
        },
      ],
      orderData: [
        {
          title: "个人信息",
          icon: 'mine_other2',
          path: "/info",
        },
        {
          title: "账户与安全",
          icon: 'mine_other2',
          path: "/accountSecurity",
        },
        {
          title: "实名认证",
          icon: 'mine_other2',
          path: "/identityCheck",
        },
        {
          title: "关于我们",
          icon: 'mine_other2',
          path: "/aboutUs",
        },
      ]
    };
  },
  created() {

  },
  activated() {
    this.checkOpenid()
  },
  mounted() {
    if (location.hostname === "zf.dtfcloud.com") {
      this.baseUrl = "https://zf.dtfcloud.com/";

    } else {
      this.baseUrl = "http://jzt.dtfcloud.com/";

    }
    this.checkOpenid()
  },
  methods: {
    checkOpenid() {
      let that = this
      let openid = localStorage.getItem("openid");
      that.$fetchPost(URL.checkOpenid.url + openid).then((res) => {
        if (res.data.code == 20000) {
          if (res.data.data.authFlag == '1') {
            that.realImg = require(`../../assets/publicImg/real-name1.png`)
          }
          setLocal("cip", res.data.data.ip);
          if (res.data.data.nickName && localStorage.getItem("isLogin") == 1) {
            this.showLogin = false
            this.showName = true
            this.userName = res.data.data.realName ? res.data.data.realName : res.data.data.nickName
            this.headerimg = res.data.data.headImg || require(`../../assets/publicImg/header.png`)
          }
        }
      });
    },
    check(item) {
      this.$router.push(item?.path);
    },
    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }

    },
    checkUp(item) {
      var authFlag = localStorage.getItem('authFlag') || null
      if (localStorage.getItem("isLogin") == '1') {
        // alert("11111111111111111")
        if (item.name == "我的订单") {
          if (authFlag == '0') {
            // Toast('未实名认证')
            Dialog.alert({
              message: '请前往，我的->个人中心->其他服务，下进行实名认证',
            }).then(() => {
              // on close
            });
            return
          } else {
            this.$router.push(item.path);
          }
        } else {
          this.$router.push(item.path);
        }
      } else {
        this.$router.push({ path: '/login', query: { isLogin: 1 } })
      }
    },
    orderList() {
      this.$router.push("/orderList/details");
    },
    requireList() {
      //   this.$router.push("/requireList/details");
    },
    login() {
      this.$router.push({ path: '/login', query: { isLogin: 1 } })
    }
  },
};
</script>
<style lang="less" scoped>
.pro-content {
  background: #fff;
  overflow: scroll;
}
.mine-header {
  width: 375px;
  height: 110px;
  background: url("../../view/mine/img/bg.png") no-repeat 100%;
  background-size: 100% 100%;
  .mine-header-user {
    width: 355px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    .mine-header-left {
      display: flex;
      // overflow: hidden;
      align-items: center;
      // border: 1px solid;
      .mine-use-img {
        width: 65px;
        height: 65px;
        margin-top: 9px;
        position: relative;
        .real-img {
          width: 35px;
          position: absolute;
          bottom: -1px;
          left: 15px;
        }
      }
      .mine-user {
        width: 87.5px;
        height: 79.5px;
        text-align: center;
      }
      .check-log {
        margin-top: 21.5px;
        font-size: 15px;
        font-weight: Bold;
        font-family: PingFang SC;
        color: #333333;
      }
      .log-text {
        margin-top: 12px;
      }
    }
    .mine-header-right {
      margin-top: 15.5px;
      .svg-icon {
        width: 26.5px;
        height: 25px;
      }
    }
  }
  .mine-nav {
    width: 355px;
    height: 43px;
    margin: 19.5px auto 0 auto;
    img {
      width: 100%;
    }
  }
}
.customer-service {
  width: 355px;
  height: auto;
  margin: 10px auto 0 auto;
  padding-bottom: 15px;
  background: url("../../assets/publicImg/con-bg2.png") no-repeat 100%;
  background-size: 100% 100%;
  .list-nav {
    padding: 11px 0 0 16.5px;
    font-size: 15px;
    font-weight: bold;
    font-family: PingFang SC;
    color: #000000;
  }
  .service-icon {
    // width: 100%;
    height: auto;
    padding: 11px 0 0 16.5px;
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    align-items: center;
    font-weight: Regular;
    font-family: "PingFang SC";
    color: #666666;
    .promote-right-img {
      .svg-icon {
        width: 24px;
        height: 23.5px;
      }
    }
    .home-line {
      width: 64.5px;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      position: relative;
    }
    .line-icon {
      width: 0.5px !important;
      height: 19.02px !important;
      position: absolute;
      top: 18px;
      right: 0;
      background: #ededed;
    }
    .promote-right-img:nth-child(5n) > .home-line > p,
    .promote-right-img:last-child > .home-line > p {
      display: none;
    }
    .promote-right-span {
      padding-top: 5px;
      font-size: 10px;
    }
  }
}
.other-service {
  width: 355px;
  height: auto;
  margin: 10px auto 21px auto;
  //   background: url("./../view/mine/img/bg3.png") no-repeat 100%;
  background-size: 100% 100%;
  .other-list {
    margin-top: 10px;
    .svg-icon {
      width: 25px;
      height: 25px;
      padding-right: 12px;
    }
  }
  .van-cell {
    height: 48.5px;
    align-items: center;
    background: transparent;
    padding: 0 0.44rem 0 0.44rem;
  }
  .van-cell__left-icon {
    width: 18.02px;
    height: 19.53px;
  }
  .van-cell__title {
    font-size: 10.5px;
    color: #333333;
    font-weight: Regular;
    font-family: PingFang SC;
  }
}
</style>
